/**
 * Modelo de Orden de Servicio
 */
export interface ServicioOS {
  fechaOperacion: string;
  fechaPago: string;
  fechaPagoProgramada?: string;
  idServicio?: string;
  servicio?: string;
  cantPax?: string;
  monto: number;
  moneda: string;
  incluye?: string;
  observaciones?: string[];
}

export interface CondicionPago {
  condicionPago: string;
  plazoDiasFit?: number;
}

export interface ProveedorRef {
  id: string;
  nombre: string;
}

export interface HistorialFechaPago {
  fechaPago: string;
  fechaModificacion: string;
}

export interface OrdenServicio {
  id?: string | null;
  condicionPago?: CondicionPago | null;
  estadoOS?: EstadoOS | null;
  fechaPago?: string | null;
  fechaPagoProgramada?: string | null;
  historialFechaPago?: HistorialFechaPago[] | null;
  monedaTarifa?: MonedaTarifa | null;
  nameProveedor?: string | null;
  numberFile?: string | null;
  fileExtend?: string | null;
  numberOS?: string | null;
  totalGeneral?: number | null;
  objProvider?: ProveedorRef;
  nameClient?: NameClient | null;
  servicio?: ServicioOS | null;
  key?: string | null;
  tipoOrden?: 'Orden de Servicio' | null;
  montoTotal?: number | null;
  ids?: string[] | null;
  isGrouped?: boolean | null;
  idItinerary?: string | null;
  nameEmpresa?: string | null;
  group?: string | null;
  razonSocialProveedor?: string | null;
  codigoReserva?: string | null;
  fechaProceso?: string | null;
  subTotal?: number | null;
  igv?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface OrdenServicioInput {
  numberOS: number | string;
  nameProveedor: string;
  estadoOS: string;
  monedaTarifa: 'PEN' | 'USD';
  totalGeneral: number;
}


enum CondicionPagoEnum {
  Postpago = 'POSTPAGO',
  Prepago = 'PREPAGO',
}

enum EstadoOS {
  Anulado = 'ANULADO',
  Confirmed = 'CONFIRMED',
  EnProceso = 'EN PROCESO',
  Procesado = 'PROCESADO',
  Rechazado = 'RECHAZADO',
}

enum NameClient {
  AdventureLife = 'ADVENTURE LIFE',
  ExplorandesReferidas = 'EXPLORANDES REFERIDAS',
  KnowmadAdventures = 'KNOWMAD ADVENTURES',
}

enum MonedaTarifa {
  D = 'D',
  S = 'S',
}
